/**
 * @generated SignedSource<<d2673642af8f1b3f296af9424244621b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarAuctionItemsLazy_viewer$data = {
  readonly similarAuctionItemsPdpFF: boolean | null;
  readonly " $fragmentType": "PdpRespSimilarAuctionItemsLazy_viewer";
};
export type PdpRespSimilarAuctionItemsLazy_viewer$key = {
  readonly " $data"?: PdpRespSimilarAuctionItemsLazy_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarAuctionItemsLazy_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarAuctionItemsLazy_viewer",
  "selections": [
    {
      "alias": "similarAuctionItemsPdpFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "similarAuctionItemsPDP"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"similarAuctionItemsPDP\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6ae31cc38d64849d6f93e0da7e53fe3c";

export default node;
